/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AcknowledgedSafetyCheck,
  AcknowledgedSafetyCheck$inboundSchema,
  AcknowledgedSafetyCheck$Outbound,
  AcknowledgedSafetyCheck$outboundSchema,
} from "./acknowledgedsafetycheck.js";
import {
  ComputerScreenshot,
  ComputerScreenshot$inboundSchema,
  ComputerScreenshot$Outbound,
  ComputerScreenshot$outboundSchema,
} from "./computerscreenshot.js";
import {
  Status,
  Status$inboundSchema,
  Status$outboundSchema,
} from "./status.js";

/**
 * Computer call output item: Output emitted by a computer-use tool call, typically including screenshot data.
 */
export type ComputerToolCallOutputWithId = {
  type: "computer_call_output";
  callId: string;
  output: ComputerScreenshot;
  acknowledgedSafetyChecks?: Array<AcknowledgedSafetyCheck> | undefined;
  /**
   * The unique ID of the message.
   */
  id: string;
  /**
   * The processing status of an individual item. 'in_progress' means currently processing, 'completed' means finished successfully, 'incomplete' means processing stopped before completion.
   */
  status?: Status | undefined;
  /**
   * The ID of the response that created this item, if any.
   */
  responseId?: string | null | undefined;
  /**
   * Metadata from the response that created this item, if any.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const ComputerToolCallOutputWithId$inboundSchema: z.ZodType<
  ComputerToolCallOutputWithId,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("computer_call_output"),
  call_id: z.string(),
  output: ComputerScreenshot$inboundSchema,
  acknowledged_safety_checks: z.array(AcknowledgedSafetyCheck$inboundSchema)
    .optional(),
  id: z.string(),
  status: Status$inboundSchema.optional(),
  response_id: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "call_id": "callId",
    "acknowledged_safety_checks": "acknowledgedSafetyChecks",
    "response_id": "responseId",
  });
});
/** @internal */
export type ComputerToolCallOutputWithId$Outbound = {
  type: "computer_call_output";
  call_id: string;
  output: ComputerScreenshot$Outbound;
  acknowledged_safety_checks?:
    | Array<AcknowledgedSafetyCheck$Outbound>
    | undefined;
  id: string;
  status?: string | undefined;
  response_id?: string | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const ComputerToolCallOutputWithId$outboundSchema: z.ZodType<
  ComputerToolCallOutputWithId$Outbound,
  z.ZodTypeDef,
  ComputerToolCallOutputWithId
> = z.object({
  type: z.literal("computer_call_output"),
  callId: z.string(),
  output: ComputerScreenshot$outboundSchema,
  acknowledgedSafetyChecks: z.array(AcknowledgedSafetyCheck$outboundSchema)
    .optional(),
  id: z.string(),
  status: Status$outboundSchema.optional(),
  responseId: z.nullable(z.string()).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    callId: "call_id",
    acknowledgedSafetyChecks: "acknowledged_safety_checks",
    responseId: "response_id",
  });
});

export function computerToolCallOutputWithIdToJSON(
  computerToolCallOutputWithId: ComputerToolCallOutputWithId,
): string {
  return JSON.stringify(
    ComputerToolCallOutputWithId$outboundSchema.parse(
      computerToolCallOutputWithId,
    ),
  );
}
export function computerToolCallOutputWithIdFromJSON(
  jsonString: string,
): SafeParseResult<ComputerToolCallOutputWithId, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputerToolCallOutputWithId$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputerToolCallOutputWithId' from JSON`,
  );
}
